import { AppUserAreaType } from "../enums/global.enums";
import { DatabaseRecord } from "../repos/table.repo";

export interface AppUserModelCreate {
    passwordHash?: string
}

export interface AppUserModel extends DatabaseRecord, AppUserModelCreate {
    userName: string;
    departmentId?: string;
    phone?: string;
    code?: string;
    fullName: string;
    birthOfDate?: Date;
    title?: string;
    email: string;
    avatar?: string;
    isActive: boolean;
    waterFactoryId?: string;
    isWaterFactoryAdmin: boolean;
    cccd?: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
    status?: string;
    areas?: string|string[];
}

export class AppUserModelFactory {
    static getEmpty(factoryId: string = ""): AppUserModel {
      return {
        userName: "",
        phone: "",
        code: "",
        fullName: "",
        birthOfDate: undefined,
        title: "",
        email: "",
        avatar: "",
        isActive: false,
        waterFactoryId: factoryId,
        isWaterFactoryAdmin: false,
        cccd: "",
        id: "",
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: "",
        updatedBy: "",
        status: ""
      };
    }
  }
  